// extracted by mini-css-extract-plugin
export default {"header":"connectHeader_header__uzX-V","primary":"connectHeader_primary__MU71r","outlinePrimary":"connectHeader_outlinePrimary__TvY4Z"};